import { Component } from '@angular/core';
import { BaseComponentContext } from '../../../../modules/tcm-core.module';
import { BroadCastEvents } from '../../../../common/broad-cast-events.enum';
import { CompanyDataService } from '../../../../services';
import { UpdateCompanyLogoRequest } from '../../../../models/companies';

@Component({
    selector: 'update-company-logo',
    templateUrl: './update-company-logo.component.html',
    styleUrls: ['./update-company-logo.component.scss'],
    standalone: false
})
export class UpdateCompanyLogoComponent {
  public requestModel: any;

  public isLoading: boolean;

  public base64img: string;

  public constructor(private componentContext: BaseComponentContext, private companyDataService: CompanyDataService) {
  }

  goBack(data?: any) {
    this.componentContext.navService.navigateBack(data);
  }

  public async save() {
    if (this.base64img) {
      var request = {} as UpdateCompanyLogoRequest;

      request.companyId = this.requestModel.companyId;
      request.base64string = this.base64img;

      try {
        this.isLoading = true;
        await this.companyDataService.updateCompanyLogoAsync(request);
      }
      finally {
        this.isLoading = false;
      }

      this.componentContext.broadcastService.next({ name: BroadCastEvents.CompanyLogoChanged, args: { src: this.base64img } });
      this.goBack();
    }
  }

  public onPictureLoaded(args: any) {
    this.base64img = args.base64string;
  }
}
